module.exports = __webpack_public_path__ + "static/keralit-3-150a0f4ab2ba33c2064615913071037a.jpg";